<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="toc"><a href="#/chapter01">One: City Sidewalks, Busy Sidewalks</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Two: One Hundred Thousand Twinkling Lights</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Three: Let’s Have a Parade</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Four: Deck the Malls</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Five: Raisins for Rudolph</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Six: Home for the Holidays</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b6022594